import config from '../data/config.json';

import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

import { Sesion } from '../main.js';
import { loc2string } from './util.js';

let app;
let analytics;
let eventData = undefined;

function getFirebaseApp() {
	if (!app)
		app = initializeApp(config.firebaseConfig);
	return app;
}

function initMapEvent() {
	eventData = {};
	// inicializo content_type, content_id, ifn, map_type, num_cells, urls_network y urls_cache
	eventData.content_type = 'map';
	eventData.content_id = loc2string(Sesion.estado.loc);
	eventData.ifn = Sesion.estado.ifn;
	eventData.map_type = Sesion.estado.mapType;
	eventData.map_details = Sesion.estado.mapDetails;
	eventData.num_cells = 0;
	eventData.urls_network = 0;
	eventData.urls_cache = 0;
	// timestamp in milliseconds
	eventData.init = Date.now();
}

function initTimedEvent(initData) {
	eventData = {};
	// inicializo lo que me pase
	for (const key in initData)
		eventData[key] = initData[key];
	// timestamp in milliseconds
	eventData.init = Date.now();
}

// común a cualquier evento para incluir lo que haga falta
function setEventData(key, value) {
	if (eventData != undefined) 
		eventData[key] = value;
}

// común a eventos select_content de mapa y de contenidos medibles
function sendTimedEvent(eventName) {
	if (eventData != undefined) {
		// timestamp de fin en milisegundos
		eventData.end = Date.now(); // timestamp in milliseconds 		
		// calculo latencia y elimino init y end
		eventData.latency_ms = eventData.end - eventData.init;
		delete eventData.end;
		delete eventData.init;
		// envío el evento (por defecto evento 'select_content')
		const en = eventName? eventName : 'select_content';
		sendEvent(en, eventData);	
	}
}

// caso especial para timeout del mapa
function sendMapTimeoutEvent() {
	if (eventData != undefined) {
		// cambio el content_type
		eventData.content_type = 'map_timeout';	
		// pongo por latencia el timeout y elimino init y end
		eventData.latency_ms = Sesion.timeout;
		delete eventData.end;
		delete eventData.init;
		// envío el evento
		sendEvent('select_content', eventData);
	}
}

// mando evento
function sendEvent(eventName, edata) {
	//console.warn("- Enviando a GA evento de tipo " + eventName + " - Datos evento:")
	//console.warn(edata);
	if (!analytics)
		analytics = getAnalytics(getFirebaseApp());	
	logEvent(analytics, eventName, edata);
}

export { getFirebaseApp, initMapEvent, initTimedEvent, setEventData, sendTimedEvent, sendMapTimeoutEvent, sendEvent };
